import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { Flag } from '@bibliocommons/deprecated-base-icons';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { FormattedMessage } from 'react-intl';

export default class GroupSearchFeedbackButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    this.props.handleClick(this.props.bib);
  }

  render() {
    return (
      <TextButton className="cp-group-search-feedback-button" handleClick={this.handleClick}>
        <ScreenReaderMessage>
          <FormattedMessage id="group_search_feedback" />
        </ScreenReaderMessage>
        <Flag />
      </TextButton>
    );
  }
}

GroupSearchFeedbackButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  bib: ImmutablePropTypes.map
};
